import React from "react";

const AddQuizIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="63.424"
      height="33.459"
      viewBox="0 0 63.424 33.459"
    >
      <g id="db23" transform="translate(-5.392 -29.757)">
        <path
          id="Path_1226"
          data-name="Path 1226"
          d="M66.386,52.455,61.365,47.4l-2.4,2.4,7.423,7.422L76.85,46.793l-2.4-2.4Z"
          transform="translate(-15.82 -4.322)"
          fill={fill ? fill : "#a07eff"}
        />
        <path
          id="Path_1227"
          data-name="Path 1227"
          d="M52.086,29.757A16.736,16.736,0,0,0,37.1,39.089a16.729,16.729,0,1,0,0,14.8A16.721,16.721,0,1,0,52.086,29.757ZM29.59,51.539l-2.4,2.4-5.054-5.086-5.084,5.086-2.4-2.4,5.086-5.051-5.022-5.054,2.4-2.4,5.02,5.053,5.054-5.053,2.4,2.4-5.083,5.054Zm22.5,7.449a12.5,12.5,0,1,1,12.5-12.5A12.515,12.515,0,0,1,52.086,58.988Z"
          fill={fill ? fill : "#a07eff"}
        />
      </g>
    </svg>
  );
};

export default AddQuizIcon;
